import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router';
import { toast } from 'react-toastify';

import { getBalance } from '@/redux/parcel/asyncRequest';
import { AppDispatch, RootState } from '@/redux/store';

const RechargeBalanceCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { profile } = useSelector((state: RootState) => state.parcel);

  useEffect(() => {
    const status = searchParams.get('status');

    // Early return si no hay profile data cargado
    if (!profile.data) {
      navigate('/', { replace: true });
      return;
    }

    const isPrepaid = profile.data.configuration.paymentType === 'PREPAID';

    // Actualizar el balance si el pago fue exitoso y es cuenta prepago
    if (status && isSuccessStatus(status) && isPrepaid) {
      dispatch(getBalance());
    }

    // Limpiar la URL y redirigir inmediatamente
    navigate('/', { replace: true });

    // Mostrar el resultado basado en el status
    if (status) {
      handlePaymentStatus(status);
    }
  }, [searchParams, navigate, dispatch, profile.data]);

  const isSuccessStatus = (status: string): boolean => {
    const successStatuses = ['accept', 'completed'];
    return successStatuses.includes(status.toLowerCase());
  };

  const handlePaymentStatus = (status: string) => {
    switch (status.toLowerCase()) {
      case 'accept':
      case 'completed':
        toast.success(
          '¡Recarga exitosa! Tu saldo se ha actualizado correctamente. Esto puede tomar algunos minutos en reflejarse.',
          {
            autoClose: 5000,
          },
        );
        break;

      case 'fail':
        toast.error('No se pudo completar la recarga. Por favor, intenta nuevamente.', {
          autoClose: 5000,
        });
        break;

      case 'cancel':
        toast.warning('Has cancelado el proceso de recarga.', {
          autoClose: 5000,
        });
        break;

      default:
        toast.info('Procesando tu solicitud de recarga...', {
          autoClose: 3000,
        });
        break;
    }
  };

  return (
    <Container
      maxWidth="xxl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 3,
      }}
    >
      <CircularProgress size={60} />
      <Box textAlign="center">
        <Typography variant="h6" gutterBottom>
          Procesando tu recarga...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Serás redirigido automáticamente
        </Typography>
      </Box>
    </Container>
  );
};

export default RechargeBalanceCallback;
